import React from 'react';
import { Claim } from '@gjensidige/builders-icons/products';
import { Nav } from '@gjensidige/core-navigation';

import { ROUTE } from '../utils/routes';
import { IS_BEDRIFT } from '../utils/utils';

const NavAnmeldSkade = () => (
  <Nav.Item icon={<Claim />} label={'Anmeld skade'} href={IS_BEDRIFT ? '/addstuffhere' : ROUTE.ANMELD_SKADE} />
);

export default NavAnmeldSkade;
